/**
 * Family-local layout for lokalhyra. Generic slot/value/bilaga helpers come
 * from `common/`; only the idioms specific to this template live here.
 */
import { p, section, strong, t, val } from '@hyranai/regta-document-ir';
import { formatSlotNumber, slotText } from '../common/slots.js';
/** A computed amount (not a slot value) printed like the legacy `num()`, with a unit suffix. */
export function amountVal(ctx, amount, sourceKey, suffix = '') {
    const text = formatSlotNumber(ctx, amount);
    return val(text == null ? null : `${text}${suffix}`, { raw: amount, format: 'number', blankWidth: 'short', sourceKey });
}
/** The legacy InlineSlot: number → formatted, non-empty string → as is, else a fill-in rule. */
export const inlineSlot = (ctx, value, sourceKey) => {
    if (typeof value === 'number')
        return amountVal(ctx, value, sourceKey);
    return val(typeof value === 'string' && value.trim() !== '' ? value : null, { blankWidth: 'short', sourceKey });
};
/** Free text authored with blank-line paragraph breaks (whitespace-pre-wrap in the legacy body). */
export function freeTextParagraphs(value, sourceKey) {
    const text = slotText(value);
    if (!text)
        return [p([val(null, { blankWidth: 'full', sourceKey })])];
    return text
        .split(/\n{2,}/)
        .map((chunk) => chunk.trim())
        .filter((chunk) => chunk !== '')
        .map((chunk) => p([val(chunk, { sourceKey })]));
}
/** "Lead. Body" paragraph with a bold lead — the legacy `<span font-semibold>` idiom. */
export const leadP = (lead, body, opts = {}) => p([strong(lead), ...body.map((b) => (typeof b === 'string' ? t(b) : b))], opts);
export const sub = (ref, title, content, opts = {}) => section(ref, title, content, opts);
/** A bilaga slot (legacy `attachment_ref` field, "Pattern B"). */
export const attachmentSlot = (key, label, extra = {}) => ({
    key,
    label,
    type: 'attachment',
    ...extra,
});
//# sourceMappingURL=helpers.js.map